import { useEffect, useRef } from 'react';

export const useLazyLoadImage = (src) => {
  const imageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const image = entry.target;

            if (image.href && image.href.baseVal !== undefined) {
              image.href.baseVal = src;
            } else {
              image.setAttribute('href', src);
            }

            observer.unobserve(image);
          }
        });
      },
      { rootMargin: '0px 0px 50px 0px' }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, [src]);

  return imageRef;
};